import Vue from "vue";
import Vuex from "vuex";

import user from "./module/user";
import app from "./module/app";
import initAdmin from './actions/initAdminAction';
import {getDate, getFullDate, dateFormat, computeDateByDay} from '@/libs/timeUtil';
import {getOperationTimeDesc} from "@/libs/util";
// const timeUtil = require("@/libs/timeUtil");

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		hasChromeApp: false,
		// 所有sku id对应cover
		allSkus: {},
		// 供应商列表
		allSuppliers: [],
		// 所有称重框
		allTurnoverBoxs: [],
		allTurnoverBoxsObj: {},
		// 刷新页面数据
		flushPage: false,
		// 渠道商端-应用列表-功能模块配置
		platform_setting: '',
		preSortingType: 1, // 预分拣类型 1全部商品 2参考销售情况
		// 时间类型 1按发货日期 2按运营时间
		dateType: 1,
		// 分拣时间
		sortingTimes: null,
		// 当前选择分拣时间
		currentSortingTimeIndex: 0,
		// 运营时间
		operationTimes: [{title: "默认运营时间", end_type: 1, start_time: "00:00", end_time: "23:59"}],
		// 分拣时间段
		sortingTimeSetting: {
			sortingTimeName: "默认运营时间",
			sortingStartTime: getDate(),
			sortingEndTime: getFullDate(),
			sortingTimeDesc: dateFormat(getFullDate(), "M月D日") + "00:00 ~ " + dateFormat(getFullDate(), "M月D日") + "23:59",
			spuCategoryIds: []
		},
		// 称重框设置信息
		boxSetting: {
			// 自动借出周转物
			autoLent: "false",
			// 选择称重框信息
			selectBoxList: [],
			// 展示周转物配置信息
			showWeight: 0,
			showCount: 0,
		},
		// 软件设置
		softwareSetting: {
			// 自动打印标签 1开启
			autoPrint: "1",
			// 称重偏差提醒 1开启
			weighingRemind: "2",
			// 称重偏差阈值
			weighingRemindSize: 0,
			// 分拣商品分组类型 1按sku 2按spu
			skuGroupType: 1,
			// 已分拣后移 1开启
			sortingMoved: 2,
			// 装箱设置
			openBox: 2,
			// 自动打印箱签
			autoPrintBoxLabel: 2,
			// 散件装箱商品分拣后自动标记装箱任务
			autoPartBoxTask: 1,
			// 整件装箱商品分拣后自动装箱
			autoWholeBox: 1
		},
		// vuex是否加载完毕
		storeComplete: false
	},
	mutations: {
		openChromeApp(state, value) {
			state.hasChromeApp = true;
		},
		initPage(state, getData) {
			state.platform_setting = getData.platform_setting;
			if (getData.softwareSetting) {
				state.softwareSetting = {...getData.softwareSetting};
			}
		},
		// 初始化称重框
		initTurnoverBoxs(state, getData) {
			state.allTurnoverBoxs = getData;
			for (let i = 0; i < getData.length; i++) {
				state.allTurnoverBoxsObj[getData[i].id] = getData[i];
			}
		},
		// 查询分拣时间
		initSortingTime(state, getData) {
			let dateType = localStorage.getItem("dateType");
			if (dateType) {
				state.dateType = Number(dateType);
			}
			// 称重框配置
			let boxSetting = getData.boxSetting;
			if (boxSetting) {
				state.boxSetting = boxSetting;
				let showCount = 0, showWeight = 0;
				for (let i = 0; i < state.boxSetting.selectBoxList.length; i++) {
					showCount += state.boxSetting.selectBoxList[i].count;
					showWeight += state.boxSetting.selectBoxList[i].weight;
				}
				state.boxSetting.showCount = showCount;
				state.boxSetting.showWeight = showWeight;
				// state.boxSetting.showWeight = changeUnit(showWeight, "g", "斤");
			}

			let setting = JSON.parse(getData.value);
			let sortingTimes = setting.sortingTimes;
			if (!sortingTimes || !sortingTimes.length) {
				state.sortingTimeSetting.sortingTimeName = "默认时间";
				state.sortingTimeSetting.sortingStartTime = getDate() + " 00:00";
				state.sortingTimeSetting.sortingEndTime = getDate() + " 23:59";
				state.sortingTimeSetting.spuCategoryIds = [];
				// console.log(state.sortingTimeSetting)
				state.storeComplete = true;
				return;
			}
			state.sortingTimes = sortingTimes;
			if (state.dateType == 2) return;

			// 判断本地缓存时间段索引
			let index = localStorage.getItem("sortingTimeIndex");
			if (!index) {
				index = 0;
			}
			state.currentSortingTimeIndex = parseInt(index);
			// 本地数据索引大于查询过来的数据长度，说明平台删除过时间配置，默认取第一条
			if (state.currentSortingTimeIndex >= sortingTimes.length)
				state.currentSortingTimeIndex = 0;
			let data = sortingTimes[state.currentSortingTimeIndex];
			if (data.beforeDay < 0)
				data.beforeDay = -data.beforeDay;
			state.sortingTimeSetting.sortingTimeName = data.name;
			state.sortingTimeSetting.sortingStartTime = dateFormat(computeDateByDay(getDate(), -data.beforeDay), "YYYY-MM-DD") + " " + data.startHour;
			state.sortingTimeSetting.sortingEndTime = dateFormat(computeDateByDay(getDate(), data.endDay), "YYYY-MM-DD") + " " + data.endHour;
			state.sortingTimeSetting.spuCategoryIds = [];
			if (data.categoryList && data.categoryList.length) {
				for (let i = 0; i < data.categoryList.length; i++) {
					state.sortingTimeSetting.spuCategoryIds.push(data.categoryList[i].id);
				}
			}
			localStorage.setItem("sortingTimeIndex", state.currentSortingTimeIndex);
			state.storeComplete = true;
		},
		// 运营时间
		initOperationTime(state, getData) {
			let dateType = localStorage.getItem("dateType");
			if (dateType) {
				state.dateType = Number(dateType);
			}
			let operationTimes = getData;
			if (!getData || !getData.length) {
				// operationTimes.push({title: "默认时间"});
				state.storeComplete = true;
				return;
			}
			state.operationTimes = state.operationTimes.concat(operationTimes);

			if (state.dateType == 1) return;

			// 判断本地缓存时间段索引
			let index = localStorage.getItem("sortingTimeIndex");
			if (!index) {
				index = 0;
			}
			state.currentSortingTimeIndex = parseInt(index);

			// 本地数据索引大于查询过来的数据长度，说明平台删除过时间配置，默认取第一条
			if (state.currentSortingTimeIndex >= state.operationTimes.length)
				state.currentSortingTimeIndex = 0;
			/*let data = state.operationTimes[state.currentSortingTimeIndex];
			state.sortingTimeSetting.sortingTimeName = data.title;*/
			getOperationTimeDesc(state);
			// state.sortingTimeSetting.sortingStartTime = dateFormat(computeDateByDay(getDate(), -data.beforeDay), "YYYY-MM-DD") + " " + data.startHour;
			// state.sortingTimeSetting.sortingEndTime = dateFormat(computeDateByDay(getDate(), data.endDay), "YYYY-MM-DD") + " " + data.endHour;
			// state.sortingTimeSetting.spuCategoryIds = [];
			// if (data.categoryList && data.categoryList.length) {
			// 	for (let i = 0; i < data.categoryList.length; i++) {
			// 		state.sortingTimeSetting.spuCategoryIds.push(data.categoryList[i].id);
			// 	}
			// }
			// state.currentSortingTimeIndex = state.currentSortingTimeIndex;
			localStorage.setItem("sortingTimeIndex", state.currentSortingTimeIndex);
			state.storeComplete = true;
			// console.log("1111")
		}
	},
	actions: {
		//初始化管理后台常用数据-- 常用modal相关action
		...initAdmin,
	},
	getters: {},
	modules: {
		user,
		app,
	}
});



// WEBPACK FOOTER //
// ./src/store/index.js